import React, { useEffect, useState, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ImageComponent from 'atoms/Image';
import { AnchorWithLink } from 'atoms/Anchor';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { STORES } from 'organisms/SearchStore/AU/Config/searchStore.config';
import { UserOrderContext } from 'context/context';
import MyMapComponent from 'organisms/SearchStore/AU/Presentation/MapComponent';
import {
  checkTodayDay,
  getChannels,
  setOrderNowAnalyticsData,
} from 'organisms/SearchStore/AU/SearchStoreUtilities/SearchStoreUtils';
import { getList } from 'organisms/ScheduleOrder/ScheduleOrderUtils/ScheduleOrderUtils';
import { setLocalisationFinishAnalyticsData } from 'common/utilities/analyticsUtils';
import SEARCH_STORE_CONSTANTS from 'organisms/SearchStore/AU/Constants/SearchStoreConstants';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import {
  isEmptyEvery,
  getValueOrDefaultObject,
  getDispositionTypeOnAPIFormat,
  getAndCheck,
  getTernaryValue,
  getValueOrDefaultAlternativeObject,
  isCateringDisposition,
  createPayloadForStatusCall,
  isSupportedTenantCode,
  isAsapOrder,
} from 'common/utilities/utils';
import FavouriteStoreCard from 'organisms/AccountPage/AU/Presentation/AddressesAndStores/FavouritStoreCard';
import { ADDRESS_STORE_CONSTANTS } from '../../Constants/Constants';
import {
  ASAP_TIMING,
  LOCAL_STORAGE_KEYS,
  PICK_UP,
  DELIVERY,
  CATERING,
  STORE_MENU,
  OPEN,
} from 'common/constants/SharedConstants';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { getDispositionNewData } from 'organisms/MenusPLP/MenusPlpUtilities/MenuPLPSharedUtils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { setLocalStorage } from 'organisms/SearchStore/AU/Presentation/DispositionModuleUtils/DispositionModuleUtils';
import AlertFormInsideModel from 'molecules/Alert/Container/AlertFormInsideModel';
import AlertForm from 'molecules/Alert/Presentation/Alert/AlertForm';
import { ButtonType } from 'atoms/Buttons';
import { getBulkStoreStatus, getStoreDetails } from '@kfc-global/react-shared/redux/Actions/StoresAction';
import CONTEXT_REDUCER_MAPPING_KEY from 'common/constants/ContextReducerKeys';
import { setASAPOrderStorageData, gotoMenuPage } from 'organisms/SearchStore/AU/Presentation/SearchStoreCardDynamic';
const { SET_ORDER_NOW, SET_SCHEDULE_ORDER, CHANGE_SCHEDULE_MODE, SCHEDULE_ORDER_CLICKED, SHOW_SCHEDULE_DISPOSITION } =
  CONTEXT_REDUCER_MAPPING_KEY;

export const onClickScheduleOrder = (flag, userOrderStateDispatch, orderASAPObj) => {
  const {
    enableClickCollectScheduleOrderFlag,
    userOrderState,
    store,
    enableScheduleOrder,
    goToMenuObj,
    isSetASAPOrderStorageData,
  } = orderASAPObj;
  if (flag === SEARCH_STORE_CONSTANTS.ORDER_NOW) {
    const enableScheduleOrderFlag = enableScheduleOrder || enableClickCollectScheduleOrderFlag;
    if (isSetASAPOrderStorageData) {
      userOrderStateDispatch({
        type: START_ORDER_CONSTANTS.SET_ORDER_NOW,
        value: { showOrderNow: false },
      });
      userOrderStateDispatch({
        type: START_ORDER_CONSTANTS.SET_SCHEDULE_ORDER,
        value: { showScheduleOrder: true },
      });
      userOrderStateDispatch({
        type: START_ORDER_CONSTANTS.SET_ASAP_SCHEDULING,
        value: { enableASAPScheduling: true },
      });
      Boolean(
        enableClickCollectScheduleOrderFlag || (enableScheduleOrder && flag === SEARCH_STORE_CONSTANTS.BROWSE_MENU),
      ) &&
        gotoMenuPage(
          userOrderStateDispatch,
          goToMenuObj,
          userOrderState,
          store,
          enableScheduleOrderFlag,
          enableClickCollectScheduleOrderFlag,
        );
    } else {
      userOrderStateDispatch({
        type: SET_ORDER_NOW,
        value: { showOrderNow: true },
      });
      userOrderStateDispatch({
        type: SET_SCHEDULE_ORDER,
        value: { showScheduleOrder: false },
      });
      userOrderStateDispatch({ type: SCHEDULE_ORDER_CLICKED, value: { scheduleModeClicked: false } });
    }
  }
  if (flag === SEARCH_STORE_CONSTANTS.ORDER_SCHEDULE) {
    userOrderStateDispatch({ type: CHANGE_SCHEDULE_MODE, value: { changeScheduleModeFlag: false } });
    userOrderStateDispatch({ type: SCHEDULE_ORDER_CLICKED, value: { scheduleModeClicked: true } });
    userOrderStateDispatch({
      type: SET_ORDER_NOW,
      value: { showOrderNow: false },
    });
    userOrderStateDispatch({
      type: SET_SCHEDULE_ORDER,
      value: { showScheduleOrder: true },
    });
    userOrderStateDispatch({ type: SHOW_SCHEDULE_DISPOSITION, value: { showSheduleDisposition: true } });
  }
};
const checkDispostionIsCatering = (dispositionNew, isCateringOrderAvailable, setIsCateringOrderAvailable) =>
  isCateringDisposition(dispositionNew?.type) && setIsCateringOrderAvailable(isCateringOrderAvailable);
const FavouriteStoreContainer = props => {
  const { favouriteStores, removeFromFavoriteHandler, showMoreInfo, isMobile, savedAddresses } = props;
  const [isCateringOrderAvailable, setIsCateringOrderAvailable] = useState();
  const [currentSelectedStoreInfo, setCurrentSelectedStoreInfo] = useState({});
  const [showCateringModel, setShowCateringModel] = useState(false);
  const [showMap, setShowMap] = useState(false);
  const [showCard, setShowCard] = useState(false);
  const [latLongValues, setLatLongValues] = useState({});
  const [centerIndex, setCenterIndex] = useState(0);
  const [selectedStore, setSelectedStore] = useState(null);
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  let userParams = useSelector(data => data.appStateReducer.userStatus);
  const profileReducer = useSelector(data => data.profileReducer);
  const tenantReducer = useSelector(data => data.tenantReducer);
  const { componentOptions = {} } = getValueOrDefaultObject(tenantReducer?.componentOptions);
  const tenantId = tenantReducer?.tenantId;
  const { shouldCheckDropOffAddress = true } = getValueOrDefaultObject(
    componentOptions?.web?.shouldCheckDropOffAddress,
  );
  const enableClickCollectScheduleOrder =
    tenantReducer?.componentOptions?.web?.dispositionConfig?.enableClickCollectScheduleOrder;
  const enableScheduleOrder = tenantReducer?.componentOptions?.web?.dispositionConfig?.enableScheduleOrder;
  const allowScheduleOrderForDispositions =
    tenantReducer?.componentOptions?.web?.scheduledDelivery?.allowScheduleOrderForDispositions;
  const { localized } = userParams;
  const dispositionNew = getDispositionNewData(userOrderState);
  const enableClickCollectScheduleOrderFlag =
    enableClickCollectScheduleOrder && allowScheduleOrderForDispositions?.includes(dispositionNew?.type?.toLowerCase());
  const { allowedServices = [] } = getValueOrDefaultObject(tenantReducer?.basic);
  const { pastOrders = [], favouriteOrders = [] } = getValueOrDefaultObject(profileReducer);
  const {
    SEARCH_ORDER_DATA,
    SELECTED_TILE_DATA,
    SCHEDULE_ORDER_TIME_DATA,
    CURRENT_STORE_INFO,
    DISPOSITION_DATA,
    SCHEDULE_ORDER_DATA,
    FAV_STORE_NOT_IN_RADIUS,
    DISPOSITION_METHOD,
    SET_DISPOSITION,
  } = START_ORDER_CONSTANTS;
  const { MY_FAV_STORES } = ADDRESS_STORE_CONSTANTS;
  const dispatch = useDispatch();
  const history = useHistory();
  const goToMenuObj = { history, dispatch, tenantId, userParams };
  useEffect(() => {
    const isCateringOrderAvailableData = [...pastOrders, ...favouriteOrders].find(order =>
      isCateringDisposition(order?.service),
    );
    checkDispostionIsCatering(dispositionNew, isCateringOrderAvailableData, setIsCateringOrderAvailable);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pastOrders.length, favouriteOrders.length]);

  const searchOrderData = () => {
    userOrderStateDispatch({ type: SEARCH_ORDER_DATA, value: { showSearchStore: false } });
  };

  const currentStoresInfo = store => {
    userOrderStateDispatch({
      type: CURRENT_STORE_INFO,
      value: store,
    });
  };

  const setLocalStorageData = (storeInfoObj, dateTimeObj, dispositionTypeInfo) => {
    let store = storeInfoObj;
    selectedTileData();
    // update currently selected store info
    localStorage.setItem(LOCAL_STORAGE_KEYS.CURRENT_STORE_INFO_STORAGE, JSON.stringify(store));
    currentStoresInfo(store);
    setLocalStorage(store?.name?.[0]?.value);
    userOrderStateDispatch({
      type: SCHEDULE_ORDER_TIME_DATA,
      value: { selectedDateTime: dateTimeObj },
    });

    localStorage.setItem(LOCAL_STORAGE_KEYS.TENANT_REDUCER, JSON.stringify(tenantReducer));
    localStorage.setItem(LOCAL_STORAGE_KEYS.SELECTED_TILE, JSON.stringify({}));
    localStorage.setItem(LOCAL_STORAGE_KEYS.DISPOSITION_TYPE, dispositionTypeInfo);
    localStorage.setItem(LOCAL_STORAGE_KEYS.STORE_INFO, JSON.stringify(store));
    localStorage.setItem(LOCAL_STORAGE_KEYS.DATE_TIME_ORDER, JSON.stringify(dateTimeObj));
  };
  const dispositionType = localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_TYPE);
  const selectedTileData = () => {
    userOrderStateDispatch({ type: SELECTED_TILE_DATA, value: { selectedData: {} } });
  };

  const checkAvailablity = selectedStoreInfo => {
    const {
      futureDates,
      scheduled: initiallyScheduled,
      asap,
    } = getValueOrDefaultObject(selectedStoreInfo?.summary?.timings);
    const { interval: initialInterval = 0, startEndTime = {} } = getValueOrDefaultObject(
      initiallyScheduled?.periods?.length && initiallyScheduled.periods[0],
    );
    const { from: initialDayStartTime, to: initialDayEndTime } = getValueOrDefaultObject(startEndTime);
    const { unavailibilities } = getValueOrDefaultObject(initiallyScheduled);

    return getList(
      initialDayStartTime,
      initialDayEndTime,
      initialInterval,
      asap?.isAvailable,
      getAndCheck(futureDates?.length === 1, isSupportedTenantCode()),
      unavailibilities,
    );
  };

  const orderNowHandler = (currentSelectedStoreDetails, orderType, flag) => {
    const storeStatus = currentSelectedStoreDetails?.summary?.status?.currentStatus;
    const isStoreOpen = storeStatus === OPEN;
    const isAsapOrderFlag = isAsapOrder(currentSelectedStoreDetails);
    const isSetASAPOrderStorageData = setASAPOrderStorageData(
      enableClickCollectScheduleOrderFlag,
      enableScheduleOrder,
      isStoreOpen,
      isAsapOrderFlag,
    );
    const orderASAPObj = {
      enableClickCollectScheduleOrderFlag,
      userOrderState,
      store: currentSelectedStoreDetails,
      enableScheduleOrder,
      goToMenuObj,
      isSetASAPOrderStorageData,
    };
    onClickScheduleOrder(flag, userOrderStateDispatch, orderASAPObj);
    if (orderType === STORE_MENU) {
      if (!localized || (localized && dispositionNew?.type === CATERING.toUpperCase())) {
        userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showDisposition: true } });
        localStorage.setItem(LOCAL_STORAGE_KEYS.RETAIN_ADDRESS, [currentSelectedStoreDetails?.name[0].value]);
        return;
      }
    } else if (orderType === CATERING) {
      userOrderStateDispatch({
        type: DISPOSITION_METHOD,
        value: { dispositionType: CATERING },
      });
      userOrderStateDispatch({
        type: SEARCH_ORDER_DATA,
        value: {
          configSearchScreen: STORES,
        },
      });
      localStorage.setItem(LOCAL_STORAGE_KEYS.SERVICE_TYPE, CATERING);
    }
    userOrderStateDispatch({
      type: SET_DISPOSITION,
      value: {
        oldvalue: dispositionNew,
      },
    });

    let dateTimeObj = {
      time: ASAP_TIMING,
      interval: currentSelectedStoreDetails?.summary?.timings.scheduled.periods[0]?.interval,
      date: new Date(),
      selectedTime: ASAP_TIMING,
    };
    const payload = {
      storeID: currentSelectedStoreDetails?.id,
      disposition: dispositionNew?.type,
      postCode: currentSelectedStoreDetails?.addresses[0]?.address?.pinCode,
    };
    setLocalStorageData(currentSelectedStoreDetails, dateTimeObj, dispositionNew?.type);
    setLocalisationFinishAnalyticsData(payload);
    searchOrderData();
    if (!isSetASAPOrderStorageData || flag === SEARCH_STORE_CONSTANTS.ORDER_SCHEDULE) {
      userOrderStateDispatch({
        type: SCHEDULE_ORDER_DATA,
        value: {
          showScheduleOrderCatering: true,
          changeFlow: getTernaryValue(getAndCheck(orderType, orderType === CATERING), false, true),
        },
      });
    }
  };

  const fetchLocalizationModel = async (selectedStoreInfo, orderType, flag) => {
    const service = getTernaryValue(
      orderType === CATERING,
      getDispositionTypeOnAPIFormat(CATERING),
      getAndCheck(dispositionNew, dispositionNew?.type)
        ? getDispositionTypeOnAPIFormat(dispositionNew?.type)
        : getDispositionTypeOnAPIFormat(tenantReducer?.authoredContent?.defaultdisposition),
    );

    dispatch(
      getStoreDetails(
        {
          storeId: selectedStoreInfo?.storeBasic?.id,
          tenantId: tenantReducer?.tenantId,
        },
        selectedStoreDetailsDL => {
          const statusCallPayload = {
            data: createPayloadForStatusCall(
              [{ id: selectedStoreInfo?.storeBasic?.id }],
              service,
              null,
              shouldCheckDropOffAddress,
            ),
            store: [{ ...selectedStoreDetailsDL, service }],
            tenantId: tenantReducer?.tenantId,
          };

          dispatch(
            getBulkStoreStatus(statusCallPayload, currentStoreInfo => {
              setCurrentSelectedStoreInfo(currentStoreInfo[0]);
              orderNowHandler(currentStoreInfo[0], orderType, flag);
            }),
          );
        },
      ),
    );
  };

  /** Method to handle order now button click */
  const orderNowButtonClickHandler = async (event, selectedStoreInfo, flag) => {
    localStorage.setItem(LOCAL_STORAGE_KEYS.SET_CART_CLEAR, true);
    setCurrentSelectedStoreInfo(selectedStoreInfo);
    event.preventDefault();
    event.stopPropagation();
    setOrderNowAnalyticsData();

    const { unavailableServiceinfo } = getAvailableService(selectedStoreInfo?.availableServicesPerChannel, true);
    if (getAndCheck(isCateringOrderAvailable, !unavailableServiceinfo.includes(CATERING))) {
      setShowCateringModel(true);
      return;
    }

    let storeListWithInRadius;
    if (dispositionNew?.type === DELIVERY.toUpperCase()) {
      const eligibleStore = isEmptyEvery(userOrderState?.eligibleStore)
        ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.ELIGIBLE_STORE))
        : userOrderState?.eligibleStore;
      storeListWithInRadius = eligibleStore.find(store => store?.id === selectedStoreInfo?.storeBasic?.id);
    }

    if (!localized) {
      userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showDisposition: true } });
      localStorage.setItem(LOCAL_STORAGE_KEYS.RETAIN_ADDRESS, [selectedStoreInfo?.storeBasic?.dname[0]?.value]);
    } else {
      if (!storeListWithInRadius && dispositionNew?.type === DELIVERY.toUpperCase()) {
        userOrderStateDispatch({
          type: SEARCH_ORDER_DATA,
          value: {
            showSearchStore: true,
            searchedPlaceNonLocalized: localStorage.getItem(LOCAL_STORAGE_KEYS.RETAIN_ADDRESS),
            configSearchScreen: STORES,
          },
        });
        userOrderStateDispatch({
          type: FAV_STORE_NOT_IN_RADIUS,
          value: {
            showNotInRadiusError: true,
            notInRadiusRestaurant: selectedStoreInfo?.storeBasic?.dname[0]?.value,
          },
        });
        return;
      }

      /* newly added code for order now logic */
      fetchLocalizationModel(selectedStoreInfo, undefined, flag);
    }
  };

  const sortFavoritesStores = favourite_stores => {
    return favourite_stores.sort(function (a, b) {
      if (a.storeBasic?.dname[0]?.value < b.storeBasic?.dname[0]?.value) {
        return -1;
      }
      if (a.storeBasic?.dname[0]?.value > b.storeBasic?.dname[0]?.value) {
        return 1;
      }
      return 0;
    });
  };

  const toggleMapView = () => {
    setShowMap(!showMap);
    setShowCard(!showMap);
  };

  const setStoreMarker = latLongObj => {
    const filterStoreMarker = favouriteStores.findIndex(
      store =>
        store.storeBasic.location.latitude === latLongObj.lat() &&
        store.storeBasic.location.longitude === latLongObj.lng(),
    );
    if (filterStoreMarker > -1) {
      setCenterIndex(filterStoreMarker);
      setSelectedStore(getValueOrDefaultObject(favouriteStores[filterStoreMarker]));
    }
  };

  useEffect(() => {
    setShowCard(true);
    getLatLongInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [centerIndex, selectedStore]);

  const getLatLongInfo = () => {
    const latLongValue = favouriteStores.map(store => {
      return { lat: store.storeBasic.location.latitude, lng: store.storeBasic.location.longitude };
    });
    setLatLongValues(latLongValue);
  };

  const onPositionChangeHandler = pointer => {
    let index = pointer ? centerIndex + 1 : centerIndex - 1;
    setCenterIndex(index);
    setSelectedStore(getValueOrDefaultObject(favouriteStores[index]));
  };

  const setStoreInfo = (item, index) => {
    getLatLongInfo();
    setSelectedStore(item);
    setCenterIndex(index);
    toggleMapView();
  };

  const checkToday = item => {
    const dayAvailability = checkAvailablity(item).length;
    return getTernaryValue(
      dayAvailability,
      translateWithI18Next(TRANSLATE_MAPPING_KEY.TODAY),
      translateWithI18Next(TRANSLATE_MAPPING_KEY.TOMORROW),
    );
  };

  const timimgMsg = item => {
    const storeStatus = item.summary;
    const { operatingHours = [] } = getTernaryValue(storeStatus?.timings?.operatingHours, storeStatus?.timings, []);
    return checkTodayDay(item.isOpen, operatingHours);
  };

  const getAvailableService = (channels = [], isServiceInfo = false) => {
    const webChannel = channels && getChannels(channels);
    const { services: orderTypes = [] } = getValueOrDefaultAlternativeObject(webChannel[0], []);

    const availableServicesForWeb = orderTypes.filter(service => getDispositionTypeOnAPIFormat(service));

    const unAvailableDispositions = allowedServices?.filter(value => !availableServicesForWeb.includes(value));

    if (!isServiceInfo) {
      const availableServiceinfo = orderTypes.map((item, index) => {
        return (
          <div className='store-order-options' key={index}>
            <span>
              <ImageComponent data-testid='' srcFile={IMAGE_PATH.GreenTickImage} alt={'tick'} className='tick-image' />
            </span>
            <span>
              {getTernaryValue(
                item === PICK_UP,
                translateWithI18Next(SEARCH_STORE_CONSTANTS.PICK_UP),
                translateWithI18Next(item),
              )}
            </span>
          </div>
        );
      });

      const unavailableServiceinfo = unAvailableDispositions?.map((item, index) => (
        <div className='store-order-options' key={index}>
          <span>
            <ImageComponent
              data-testid=''
              srcFile={IMAGE_PATH.WhiteExclamatry}
              alt={'tick'}
              className='unavail-tick-image tick-image'
            />
          </span>
          {getTernaryValue(
            item === PICK_UP,
            translateWithI18Next(SEARCH_STORE_CONSTANTS.PICK_UP),
            translateWithI18Next(item),
          )}
        </div>
      ));

      return [...availableServiceinfo, ...unavailableServiceinfo];
    } else {
      return {
        availableServiceinfo: availableServicesForWeb,
        unavailableServiceinfo: unAvailableDispositions,
      };
    }
  };

  const clearFlag = () => {
    localStorage.removeItem(LOCAL_STORAGE_KEYS.SET_CART_CLEAR);
  };

  const storeCard = (item, index, classname) => (
    <FavouriteStoreCard
      item={item}
      isMobile={isMobile}
      index={index}
      classname={classname}
      setStoreInfo={setStoreInfo}
      timimgMsg={timimgMsg}
      dispositionType={dispositionType}
      checkToday={checkToday}
      showAvailableService={getAvailableService}
      showMap={showMap}
      removeFromFavoriteHandler={removeFromFavoriteHandler}
      orderNowButtonClickHandler={orderNowButtonClickHandler}
      cardHeading={`${centerIndex + 1} of ${favouriteStores.length}`}
      showMoreInfo={showMoreInfo}
      setShowCard={setShowCard}
      showDistance={(!localized && savedAddresses.length > 0) || localized}
    />
  );

  const favStoreCard = sortFavoritesStores(favouriteStores).map((item, index) => storeCard(item, index));

  return (
    <>
      <div className='favorite-stores-section'>
        {favouriteStores.length > 0 && (
          <div className='header-text'>
            {translateWithI18Next(MY_FAV_STORES)} ({favouriteStores.length})
            {showMap && (
              <span
                data-testid='list-handler'
                onClick={() => {
                  toggleMapView();
                  getLatLongInfo();
                }}
              >
                <AnchorWithLink className='map-link-list'>
                  <span>
                    <ImageComponent data-testid='' srcFile={IMAGE_PATH.Union} alt={'map'} className='map-img' />
                  </span>
                  {translateWithI18Next(SEARCH_STORE_CONSTANTS.LIST_TEXT)}
                </AnchorWithLink>
              </span>
            )}
          </div>
        )}
        {favouriteStores.length > 0 && !showMap > 0 && favStoreCard}
        {showMap && (
          <>
            <div className={`takeawayDineInMap delivery-map`}>
              <>
                <MyMapComponent
                  data-testid='mymap-id'
                  latLongValue={latLongValues}
                  loadingElement={<div style={{ height: `100%` }} />}
                  containerElement={<div style={{ height: `400px` }} />}
                  mapElement={<div style={{ height: `100%` }} />}
                  isVisible={true}
                  isMobile={isMobile}
                  centerIndex={centerIndex}
                  onPositionChangeHandler={onPositionChangeHandler}
                  setShowCard={setShowCard}
                  setStoreMarker={setStoreMarker}
                  storeCardHeight={325}
                />
                {showCard && selectedStore && isMobile ? storeCard(selectedStore, '', 'Selected-mobile-Card') : null}
              </>
              {showCard && selectedStore && !isMobile ? storeCard(selectedStore, '', 'Selected-desktop-Card') : null}
            </div>
          </>
        )}
      </div>
      {showCateringModel && (
        <AlertFormInsideModel
          handleClose={() => {
            setShowCateringModel(false);
            clearFlag();
          }}
          classNames='clear-cart-modal item-unavailable'
          CartAlertForm={
            <AlertForm
              title={translateWithI18Next(TRANSLATE_MAPPING_KEY.WHICH_MENU)}
              imageSrc={IMAGE_PATH?.TakeawayCompleted}
              altText={''}
              confirmButtonText={translateWithI18Next(TRANSLATE_MAPPING_KEY.CATERTING_MENU)}
              confirmHandler={() => {
                fetchLocalizationModel(currentSelectedStoreInfo, CATERING);
                setShowCateringModel(false);
              }}
              cancelButtonText={translateWithI18Next(TRANSLATE_MAPPING_KEY.STORE_MENU)}
              cancelHandler={() => {
                fetchLocalizationModel(currentSelectedStoreInfo, STORE_MENU);
                setShowCateringModel(false);
              }}
              secondaryButtonType={ButtonType.tertiary}
            />
          }
        />
      )}
    </>
  );
};

export default FavouriteStoreContainer;
